export const NOTE_GENERAL_TITLE = 'Please provide details for your requests';

export const items = [
    {
        id: '1',
        name: 'prescription-renewal',
        label: 'Prescription Renewal',
        note: {
            title: 'Additional details for the doctor:',
            required: false,
            placeholder: '',
        }
    },
    {
        id: '2',
        name: 'new-symptoms',
        label: 'New Symptoms',
        note: {
            title: 'Please provide any additional details about your symptoms or condition:',
            required: true,
            placeholder: 'You can include test results, recent health changes, or any concerns you have.',
        }
    },
    {
        id: '3',
        name: 'lab-requisition-or-medical-imaging',
        label: 'Lab Requisition / Medical Imaging',
        note: {
            title: 'What tests are you requesting?',
            required: true,
            placeholder: 'Specify the tests or imaging required (e.g., blood test, X-ray, MRI).',
        }
    },
    {
        id: '4',
        name: 'medical-note-or-forms',
        label: 'Medical Note / Forms',
        note: {
            title: 'Why do you need this medical note?',
            required: true,
            placeholder: 'Provide details such as reason (e.g., work leave), type of note, and duration.',
        }
    },
    {
        id: '5',
        name: 'referral',
        label: 'Referral',
        note: {
            title: 'Why do you need a referral?',
            required: true,
            placeholder: 'State the specialist and reason (e.g., dermatologist for a skin condition).',
        }
    }
];

export const symptoms = [
    {
        id: '1',
        name: 'eye-or-throat-infection',
        label: 'Eye / Throat Infection'
    },
    {
        id: '2',
        name: 'cold-or-flu',
        label: 'Cold / Flu'
    },
    {
        id: '3',
        name: 'sexual-health-issues',
        label: 'Sexual Health Issues'
    },
    {
        id: '4',
        name: 'anxiety-or-depression',
        label: 'Anxiety / Depression'
    },
    {
        id: '5',
        name: 'diarrhea-or-constipation',
        label: 'Diarrhea / Constipation'
    },
    {
        id: '6',
        name: 'allergic-reaction',
        label: 'Allergic Reaction'
    },
    {
        id: '7',
        name: 'ear-discharge',
        label: 'Ear Discharge'
    },
    {
        id: '8',
        name: 'urinary-infection',
        label: 'Urinary Infection'
    },
    {
        id: '9',
        name: 'skin-problem',
        label: 'Skin Problem'
    },
    {
        id: '10',
        name: 'headache',
        label: 'Headache'
    },
    {
        id: '11',
        name: 'minor-injury-or-joint-pain',
        label: 'Minor Injury / Joint Pain'
    },
    {
        id: '12',
        name: 'abdominal-pain',
        label: 'Abdominal Pain'
    },
    {
        id: '13',
        name: 'back-pain',
        label: 'Back Pain'
    },
    {
        id: '14',
        name: 'other',
        label: 'Other'
    }
];
